import { render, staticRenderFns } from "./GeetestCaptcha.vue?vue&type=template&id=64e32646&scoped=true"
import script from "./GeetestCaptcha.vue?vue&type=script&lang=ts"
export * from "./GeetestCaptcha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e32646",
  null
  
)

export default component.exports